import { all } from 'redux-saga/effects';
import ChangePasswordSaga from './auth/changepwd/saga';
import DeleteUserSaga from './auth/delete/saga';
import ForgetSaga from './auth/forgetpwd/saga';
import GetUsersSaga from './auth/get/saga';
import AuthSaga from './auth/login/saga';
/* PUBLIC */
// Users
import AccountSaga from './auth/register/saga';
import StatusUserSaga from './auth/status/saga';
import UpdateUserSaga from './auth/update/saga';
import LayoutSaga from './layout/saga';
// Map
import GetAllMapSaga from './map/get/saga';
import getQueuePositionsSaga from './map/getQueuePositions/saga';
import getRotatePositionsSaga from './map/getRotatePositions/saga';
import getMapPositionsSaga from './map/getMapPositions/saga';
import getPositionTypesSaga from './map/getPositionTypes/saga';
// Parameters
import GetAllParamsSaga from './parameters/getAll/saga';
import GetTypeParamsSaga from './parameters/getType/saga';
import UpdateParamGroupSaga from './parameters/updateParamGroup/saga';
// Racks
import GetRacksSaga from './racks/get/saga';
import getAllRacksSaga from './racks/getAll/saga';
import getCarrierTypesSaga from './racks/getCarrierTypes/saga';

import createParametersSaga from './securityparams/create/saga';
import deleteParametersSaga from './securityparams/delete/saga';
// Security params
import getParametersSaga from './securityparams/get/saga';
//System
import GetSystemStatusSaga from './system/get/saga';
import CancelTaskSaga from './task/cancel/saga';
import CreateTaskSaga from './task/create/saga';
import getPlcStatusSaga from './system/plcStatus/saga';
import getPlcPopupStatusSaga from './system/plcPopupStatus/saga';
import setPlcPopupStatusSaga from './system/setplcPopupStatus/saga';
// Tasks
import GetTasksSaga from './task/get/saga';
import getLastTaskSaga from './task/getLast/saga';
import pendingToReturnTaskSaga from './task/pentingToReturn/saga';
import queryTaskStatusStartSaga from './task/queryTaskStatus/saga';
import resendTaskSaga from './task/resend/saga';
import ReturnTaskSaga from './task/return/saga';
import UpdateTaskSaga from './task/update/saga';
import pauseQueueTaskSaga from './task/pauseQueueTask/saga';
import resumeQueueTaskSaga from './task/resumeQueueTask/saga';
import getDashboardQueueTasksSaga from './task/getDashboardQueue/saga';
import getDashboardSendTasksSaga from './task/getDashboardSend/saga';
import getDashboardCancelledTasksSaga from './task/getDashboardCancelled/saga';
import getDashboardFinishTasksSaga from './task/getDashboardFinish/saga';
import getTaskDashboardStatsSaga from './task/getDashboardStats/saga';
import getTaskTrendSaga from './task/getTaskTrend/saga';
import getCallbacksSaga from './task/getCallbacksPending/saga';
import sendCallbacksSaga from './task/sendCallbacksPending/saga';
// Warnings
import GetAllWarningsSaga from './warnings/get/saga';
import BlockWorkstationSaga from './workstation/blockWorkstation/saga';
import CancelAllTasksWorkstationSaga from './workstation/cancelAllTasks/saga';
import CheckWSPositionsSaga from './workstation/checkWsPositions/saga';
// Workstations
import CreateWSSaga from './workstation/create/saga';
import DeleteWSSaga from './workstation/delete/saga';
import GetWSSaga from './workstation/get/saga';
import GetNullWSPositionsSaga from './workstation/getNullWsPositions/saga';
import lockWSPositionSaga from './workstation/lockWSPosition/saga';
import UnBlockWorkstationSaga from './workstation/unblockWorkstation/saga';
import unlockWSPositionSaga from './workstation/unlockWSPosition/saga';
import UpdateWSSaga from './workstation/update/saga';
import checkWorkWSPositionSaga from './workstation/updateCheckWork/saga';
import getWsPositionsSaga from './workstation/getWsPositions/saga';
import StrictWorkstationsSaga from './workstation/strictPriority/saga';
import UnstrictWorkstationsSaga from './workstation/unstrictPriority/saga';
import UpdateWorkStatusWSSaga from './workstation/updateWorkStatusWorkstation/saga';
import AddQueuePositionSaga from './workstation/addQueues/saga';
import AddRotationPositionSaga from './workstation/addRotation/saga';
import UpdateFacesValuesSaga from './workstation/updateFacesValues/saga';
import getWorkstationPositionsStatusSaga from './workstation/getPositionsStatus/saga';
//DMX (AA-11839)
import getDmxControllersSaga from './dmx/getControllers/saga';
import createDmxControllerSaga from './dmx/createController/saga';
import updateDmxControllerSaga from './dmx/updateController/saga';
import toggleDmxControllerStatusSaga from './dmx/toggleControllerStatus/saga';
import deleteDmxControllerSaga from './dmx/deleteController/saga';
import toggleDmxUniverseStatusSaga from './dmx/toggleUniverseStatus/saga';
import getDmxUniversesByControllerSaga from './dmx/getUniversesByController/saga';
import createDmxUniverseSaga from './dmx/createUniverse/saga';
import deleteDmxUniverseSaga from './dmx/deleteUniverse/saga';
import getDmxOccupancySaga from './dmx/getOccupancy/saga';
import getDmxDeviceByIdSaga from './dmx/getDeviceById/saga';
import createDmxDeviceSaga from './dmx/createDevice/saga';
import updateDmxDeviceSaga from './dmx/updateDevice/saga';
import deleteDmxDeviceSaga from './dmx/deleteDevice/saga';
import getDmxProfilesSaga from './dmx/getProfiles/saga';
import getDmxProfileByIdSaga from './dmx/getProfileById/saga';
import createDmxProfileSaga from './dmx/createProfile/saga';
import updateDmxProfileSaga from './dmx/updateProfile/saga';
import deleteDmxProfileSaga from './dmx/deleteProfile/saga';
import setDmxProfileChannelsSaga from './dmx/setProfileChannels/saga';
import getDmxDevicePresetsSaga from './dmx/getDevicePresets/saga';
import getDmxDevicePresetByIdSaga from './dmx/getDevicePresetById/saga';
import createDmxDevicePresetSaga from './dmx/createDevicePreset/saga';
import updateDmxDevicePresetSaga from './dmx/updateDevicePreset/saga';
import deleteDmxDevicePresetSaga from './dmx/deleteDevicePreset/saga';
import activateDmxDevicePresetSaga from './dmx/activateDevicePreset/saga';
import getDmxCompatibleDevicesSaga from './dmx/getCompatibleDevices/saga';
import duplicateDmxDevicePresetsSaga from './dmx/duplicateDevicePresets/saga';
import resyncPlcSecuritiesSaga from './processingTask/resyncSecurities/saga';
// PLC Safety (P01021-135)
import getPlcSafetyZonesSaga from './plcSafety/getZones/saga';
import getPlcSafetyCausesSaga from './plcSafety/getCauses/saga';
import getPlcSafetyEventsSaga from './plcSafety/getEvents/saga';
import getPlcSafetyEventByIdSaga from './plcSafety/getEventById/saga';
import createPlcSafetyEventSaga from './plcSafety/createEvent/saga';
import updatePlcSafetyEventSaga from './plcSafety/updateEvent/saga';
import deletePlcSafetyEventSaga from './plcSafety/deleteEvent/saga';
import getPlcSafetyTriggersSaga from './plcSafety/getTriggers/saga';
import getPlcSafetyTriggerByIdSaga from './plcSafety/getTriggerById/saga';
import createPlcSafetyTriggerSaga from './plcSafety/createTrigger/saga';
import updatePlcSafetyTriggerSaga from './plcSafety/updateTrigger/saga';
import deletePlcSafetyTriggerSaga from './plcSafety/deleteTrigger/saga';
import getPlcSafetyZoneDependenciesSaga from './plcSafety/getZoneDependencies/saga';
import createPlcSafetyZoneDependencySaga from './plcSafety/createZoneDependency/saga';
import deletePlcSafetyZoneDependencySaga from './plcSafety/deleteZoneDependency/saga';
import getPlcSafetyDashboardStatsSaga from './plcSafety/getDashboardStats/saga';
// Entry Strategies
import addAreaEntryStrategySaga from './entrystrategies/addAreaEntryStrategy/saga';
import createEntryStrategySaga from './entrystrategies/createEntryStrategy/saga';
import deleteEntryStrategySaga from './entrystrategies/deleteEntryStrategy/saga';
import getEntryStrategiesSaga from './entrystrategies/getEntryStrategies/saga';
import getEntryStrategyByIdSaga from './entrystrategies/getEntryStrategyById/saga';
import removeAreaEntryStrategySaga from './entrystrategies/removeAreaEntryStrategy/saga';
import reorderAreaEntryStrategySaga from './entrystrategies/reorderAreaEntryStrategy/saga';
import toggleEntryStrategySaga from './entrystrategies/toggleEntryStrategy/saga';
import updateEntryStrategySaga from './entrystrategies/updateEntryStrategy/saga';
import toggleAreaEntryStrategySaga from './entrystrategies/toggleAreaEntryStrategy/saga';
import getDataRetentionPoliciesSaga from './dataRetention/getPolicies/saga';
import updateDataRetentionPolicySaga from './dataRetention/updatePolicy/saga';
import getDataRetentionSettingsSaga from './dataRetention/getSettings/saga';
import updateDataRetentionSettingsSaga from './dataRetention/updateSettings/saga';

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    AuthSaga(),
    ForgetSaga(),
    LayoutSaga(),
    GetUsersSaga(),
    CreateWSSaga(),
    GetWSSaga(),
    DeleteWSSaga(),
    StatusUserSaga(),
    ChangePasswordSaga(),
    UpdateWSSaga(),
    UpdateUserSaga(),
    DeleteUserSaga(),
    GetTasksSaga(),
    CreateTaskSaga(),
    GetAllParamsSaga(),
    GetTypeParamsSaga(),
    UpdateParamGroupSaga(),
    GetAllMapSaga(),
    GetAllWarningsSaga(),
    CancelTaskSaga(),
    UpdateTaskSaga(),
    GetSystemStatusSaga(),
    ReturnTaskSaga(),
    GetRacksSaga(),
    CancelAllTasksWorkstationSaga(),
    CheckWSPositionsSaga(),
    GetNullWSPositionsSaga(),
    BlockWorkstationSaga(),
    UnBlockWorkstationSaga(),
    getParametersSaga(),
    deleteParametersSaga(),
    createParametersSaga(),
    lockWSPositionSaga(),
    unlockWSPositionSaga(),
    getLastTaskSaga(),
    resendTaskSaga(),
    queryTaskStatusStartSaga(),
    pendingToReturnTaskSaga(),
    pauseQueueTaskSaga(),
    resumeQueueTaskSaga(),
    checkWorkWSPositionSaga(),
    getDashboardQueueTasksSaga(),
    getDashboardSendTasksSaga(),
    getDashboardCancelledTasksSaga(),
    getDashboardFinishTasksSaga(),
    getTaskDashboardStatsSaga(),
    getTaskTrendSaga(),
    getWsPositionsSaga(),
    getAllRacksSaga(),
    getCarrierTypesSaga(),
    getCallbacksSaga(),
    sendCallbacksSaga(),
    getPlcStatusSaga(),
    getPlcPopupStatusSaga(),
    setPlcPopupStatusSaga(),
    StrictWorkstationsSaga(),
    UnstrictWorkstationsSaga(),
    getDmxControllersSaga(),
    createDmxControllerSaga(),
    updateDmxControllerSaga(),
    toggleDmxControllerStatusSaga(),
    deleteDmxControllerSaga(),
    toggleDmxUniverseStatusSaga(),
    getDmxUniversesByControllerSaga(),
    createDmxUniverseSaga(),
    deleteDmxUniverseSaga(),
    getDmxOccupancySaga(),
    getDmxDeviceByIdSaga(),
    createDmxDeviceSaga(),
    updateDmxDeviceSaga(),
    deleteDmxDeviceSaga(),
    getDmxProfilesSaga(),
    getDmxProfileByIdSaga(),
    createDmxProfileSaga(),
    updateDmxProfileSaga(),
    deleteDmxProfileSaga(),
    setDmxProfileChannelsSaga(),
    getDmxDevicePresetsSaga(),
    getDmxDevicePresetByIdSaga(),
    createDmxDevicePresetSaga(),
    updateDmxDevicePresetSaga(),
    deleteDmxDevicePresetSaga(),
    activateDmxDevicePresetSaga(),
    getDmxCompatibleDevicesSaga(),
    duplicateDmxDevicePresetsSaga(),
    resyncPlcSecuritiesSaga(),
    getPlcSafetyZonesSaga(),
    getPlcSafetyCausesSaga(),
    getPlcSafetyEventsSaga(),
    getPlcSafetyEventByIdSaga(),
    createPlcSafetyEventSaga(),
    updatePlcSafetyEventSaga(),
    deletePlcSafetyEventSaga(),
    getPlcSafetyTriggersSaga(),
    getPlcSafetyTriggerByIdSaga(),
    createPlcSafetyTriggerSaga(),
    updatePlcSafetyTriggerSaga(),
    deletePlcSafetyTriggerSaga(),
    getPlcSafetyZoneDependenciesSaga(),
    createPlcSafetyZoneDependencySaga(),
    deletePlcSafetyZoneDependencySaga(),
    getPlcSafetyDashboardStatsSaga(),
    UpdateWorkStatusWSSaga(),
    getQueuePositionsSaga(),
    AddQueuePositionSaga(),
    getRotatePositionsSaga(),
    AddRotationPositionSaga(),
    getMapPositionsSaga(),
    getPositionTypesSaga(),
    UpdateFacesValuesSaga(),
    getWorkstationPositionsStatusSaga(),
    addAreaEntryStrategySaga(),
    createEntryStrategySaga(),
    deleteEntryStrategySaga(),
    getEntryStrategiesSaga(),
    getEntryStrategyByIdSaga(),
    removeAreaEntryStrategySaga(),
    reorderAreaEntryStrategySaga(),
    toggleEntryStrategySaga(),
    updateEntryStrategySaga(),
    toggleAreaEntryStrategySaga(),
    getDataRetentionPoliciesSaga(),
    updateDataRetentionPolicySaga(),
    getDataRetentionSettingsSaga(),
    updateDataRetentionSettingsSaga(),
  ]);
}
